import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import HeaderLogo from 'src/components/customecomponent/HeaderLogo';
import Footer from 'src/components/customecomponent/Footer';

const UserAgreement = () => {
  let today = new Date();
  today.setMonth(today.getMonth() - 6);
  const formattedDate = today.toISOString().split('T')[0];

  return (
    <>
      <Box sx={{ pb: 3, minHeight: '100vh' }}>
        <HeaderLogo />
        <Container sx={{ maxWidth: '75% !important' }}>
          <Box sx={{ p: 3 }}>
            <Typography variant="h3" fontWeight="bold" align="center">
              User Agreement
            </Typography>
          </Box>
          <Typography variant="body1" mt={2}>
            Last updated: {formattedDate}
          </Typography>

          <Typography variant="h6" mt={2}>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1">
            By accessing, browsing, or using our website and services, you acknowledge that you have read, understood,
            and agree to comply with these Terms and Conditions, along with any future updates or changes. If you do not
            agree with any part of these terms, you should not use our website or services. Your continued use of the
            site and services after modifications to the terms will be considered acceptance of those changes.
          </Typography>

          <Typography variant="h6" mt={2}>
            2. User Responsibilities
          </Typography>
          <Typography variant="body1">
            As a user of our website and services, you are responsible for ensuring that your use complies with all
            relevant local, state, and national laws, rules, and regulations. This includes not engaging in fraudulent
            activities, unauthorized access, or harmful behavior that could disrupt or damage our services, content, or
            systems. You agree not to misuse or abuse our services for unlawful or malicious purposes, including
            distributing viruses or other harmful code.
          </Typography>

          <Typography variant="h6" mt={2}>
            3. Intellectual Property
          </Typography>
          <Typography variant="body1">
            All intellectual property rights, including copyrights, trademarks, and patents, associated with our
            website, content, and services, belong exclusively to Meveltech Global Solutions Ltd. or our licensed partners. This
            includes, but is not limited to, logos, graphics, images, videos, text, designs, and software. Users are
            prohibited from using, copying, or distributing any of our protected content without explicit permission.
            Any unauthorized use may result in legal action.
          </Typography>

          <Typography variant="h6" mt={2}>
            4. Limitation of Liability
          </Typography>
          <Typography variant="body1">
            Meveltech Global Solutions Ltd. will not be liable for any direct, indirect, incidental, or consequential damages
            arising from the use or inability to use our services. This includes any errors, omissions, or interruptions
            that might occur on our website. We do not guarantee that our services will be error-free or uninterrupted,
            and we are not responsible for any loss of data, business, or opportunities arising from the use of our
            site.
          </Typography>

          <Typography variant="h6" mt={2}>
            5. Changes to Agreement
          </Typography>
          <Typography variant="body1">
            We reserve the right to amend or update these Terms and Conditions at any time without prior notice. Any
            such changes will be posted on this page, with an updated "Last Updated" date. It is your responsibility to
            review this agreement regularly. Continued use of our website or services after such updates signifies your
            acceptance of the modified terms. If you do not agree with any changes, you should discontinue using our
            services immediately.
          </Typography>

          <Typography variant="h6" mt={2}>
            6. Contact Us
          </Typography>
          <Typography variant="body1">
            If you have any questions, concerns, or require further clarification about these Terms and Conditions,
            please feel free to reach out to us. You can contact us by email at{' '}
            <strong>info@meveltech.com</strong>.We will make reasonable efforts to respond to your inquiry as
            promptly as possible.
          </Typography>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default UserAgreement;
